import { createContext } from 'react'

const ScrollContext = createContext(null)

export default ScrollContext
